import 'react-dom';

import LoginBanner from 'login/components/LoginBanner/LoginBanner.jsx';
import GuestOrSignin from 'login/components/GuestOrSignin/GuestOrSignin.jsx';
import LoginBannerContainer from 'login/components/LoginBannerContainer/LoginBannerContainer.jsx';
import Profile from 'login/components/Profile/ProfileModal.jsx';

import LocalConfigsService from 'login/services/ConfigsService/ConfigsService.js';
import TokenService from 'login/services/TokenService/TokenService.js';
import LoginLightService from 'login/services/LoginLightService/LoginLightService.js';
import UtilsService from 'login/services/UtilsService/UtilsService.js';

import * as MODALS from 'login/constants/modalNames.js';
import CONSTANTS from 'login/constants/constant.js';

const { OFFICIAL_FORM_STATUS } = CONSTANTS;

const root = LoginBanner;
const provider = LoginBannerContainer;
const main = provider;

const services = {
    LocalConfigsService,
    TokenService,
    LoginLightService,
    UtilsService,
};

export const widgets = {
    Login: {
        components: {
            root,
            provider,
            main,
            Profile,
            GuestOrSignin,
        },
        services,
        constants: { MODALS, OFFICIAL_FORM_STATUS },
    },
};

export default {
    root,
    provider,
    Login: main,
    MODALS,
    GuestOrSignin,
};
